// import { CustomerCardsDataViewModel } from '@/Alynk.dtos';
import { VHeaders } from '../pagedlistmodel';
import { VFields } from '../v-fields';

class PartSalesJson {
  public customerKey: string;
  public invoiceNumber: string;
  public documentType: string;
  public details: PartSalesDetailJson[];
  public comments?: PartSalesCommentJson[];
  public partsCounterPerson?: PartsCounterPersonJson;
  public partsTotal: string;
  public taxTotal: string;
  public shippingTotal: string;
  public specialOrderDeposit: string;
  public constructor() {
    this.partsCounterPerson = new PartsCounterPersonJson();
  }
}

interface PartSalesDetailJson {
  invoiceNumber: string;
  serviceLineNumber: string;
  sequenceNumber: string;
  partsInventory: IPartsInventoryJson;
}

interface PartSalesCommentJson {
  invoiceNumber: string;
  serviceLineNumber: string;
  sequenceNumber: string;
  comments: string;
}

interface IPartsInventoryJson {
  binLocation: string;
  partDescription: string;
  displayPartNumber: string;
  sortPartNumber: string;
}

interface IPaymentDetailResponse {
  customerName?: string;
  status: string;
  id: string;
}

interface IPaymentDetail {
  paymentResponses: IPaymentDetailResponse[];
  status: string;
  transactionHeaderId: string;
}

class PartSaleStoreDetail {
  public logo: string;
  public address: string;
  public phone: string;
  public serviceDeptPhone: string;
  public name: string;
  public terms: string;
  public storeId: number;
  public provider: string;
  public globalStoreId: string;
  public isCenposConfigured?: boolean;
  public isSquareConfigured?: boolean;
  public isCloverConfigured?: boolean;
  public isTerminalPaymentEnabled?: boolean;
}

class PartsCounterPersonJson {
  public active: string;
  public companyNumber: string;
  public employeeNumber: string;
  public id: string;
  public name: string;
}

class PartSaleCustomerInfo {
  public customerKey: string;
  public name: string;
  public address1: string;
  public address2: string;
  public city: string;
  public state: string;
  public zipCode: string;
  public homePhone: string;
  public cellPhone: string;
  public businessPhone: string;
  public email: string;
  public email2: string;
  public callTo?: string;
}

export interface IEmailViewModel {
  fromEmail?: string;
  buttonType?: string;
  invoiceNumber?: string;
  signature?: string;

  isEmail1?: boolean;
  isEmail2?: boolean;
  customerEmail1?: string;
  customerEmail2?: string;
  checkedArray?: string;
  attachmentIdArray?: string[];
  subject?: string;
  storeName?: string;
}
export interface OrderDetails {
  orderQty?: string;
  partDescription?: string;
  partNumber?: string;
}

export interface PaymentModel {
  amountToBePaid?: string;
  paymentMode?: string;
  amountPaid?: string;
  paymentType?: string;
}
export function getHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('partSales.partSalesGrid.invoiceNumber') as string,
      value: 'invoiceNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('partSales.partSalesGrid.sortName') as string,
      value: 'partsSalesJson.sortName',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partSalesGrid.invoiceDate') as string,
      value: `partsSalesJson.transDate`,
      filters: [
  (val) => {
    if (!val) return '';

    let d;

    // Case 1: YYYYMMDD (e.g. 20260119)
    if (/^\d{8}$/.test(val)) {
      const year = val.substring(0, 4);
      const month = val.substring(4, 6);
      const day = val.substring(6, 8);
      d = new Date(`${year}-${month}-${day}`);
    } 
    // Case 2: Normal date string (e.g. 12/23/2019)
    else {
      d = new Date(val);
    }

    return isNaN(d.getTime())
      ? val
      : d.toLocaleDateString('en-GB'); // dd/mm/yyyy
  },
],
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('partSales.partSalesGrid.counterPerson') as string,
      value: `partsSalesJson.counterPersonId`,
    },
    {
      align: 'left',
      sortable: true,
      text: 'Total',
      value: `partsSalesJson`,
      filters: [
        (val, item) => {
          const shipping = isNaN(
            Number(item.partsSalesJson.shippingTotal)
          )
            ? 0
            : Number(item.partsSalesJson.shippingTotal);
          const tax = isNaN(Number(item.partsSalesJson.taxTotal))
            ? 0
            : Number(item.partsSalesJson.taxTotal);
          const specialOrderDeposit = isNaN(
            Number(item.partsSalesJson.specialOrderDeposit)
          )
            ? 0
            : Number(item.partsSalesJson.specialOrderDeposit);

          const partTotal = isNaN(
            Number(item.partsSalesJson.partsTotal)
          )
            ? 0
            : Number(item.partsSalesJson.partsTotal);

          const total = partTotal + shipping + tax + specialOrderDeposit;
          return total.toFixed(2);
        },
      ],
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: 'Action',
      sortable: false,
    },
  ];
}

export function getReportHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.reportType') as string,
      value: 'recordType',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.orderNumber') as string,
      value: 'orderNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.partNumber') as string,
      value: 'partNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.manufacturer') as string,
      value: 'manufacturer',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReportGird.counterPersonName'
      ) as string,
      value: 'counterPersonName',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.quantity') as string,
      value: 'quantity',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.receivedQty') as string,
      value: 'receivedQty',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('partSales.partReportGird.syncAt') as string,
      value: 'createdAt',
      fieldType: 'date',
    },
  ];
}

export function getCashierTicketsHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('cashierTickets.grid.customerName') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('cashierTickets.grid.ticket') as string,
      value: 'ticket',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('cashierTickets.grid.openDate') as string,
      value: 'openDate',
      format: 'MM/DD/YY',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('cashierTickets.grid.total') as string,
      value: 'total',
    },
  ];
}

export function getShipmentHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.orderId'
      ) as string,
      value: 'orderId',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.status'
      ) as string,
      value: 'status',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.createdAt'
      ) as string,
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.customerName'
      ) as string,
      value: 'customerName',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.customerPhoneNumber'
      ) as string,
      value: 'customerPhoneNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.recordKey'
      ) as string,
      value: 'recordKey',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'partSalesShipment.partSalesShipmentGrid.actions'
      ) as string,
      sortable: false,
    },
  ];
}
export function AttachmentGridHeaders(
  onToggleIsPublicCallback: (...args: any[]) => void,
  vm: any
): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.attachments.attachmentGrid.invoiceNumber'
      ) as string,
      value: 'invoiceNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.attachments.attachmentGrid.attachmentType'
      ) as string,
      value: 'attachmentTypeName',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.attachments.attachmentGrid.comment'
      ) as string,
      value: 'comment',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.attachments.attachmentGrid.isPublic'
      ) as string,
      value: 'isPublic',
      fieldType: 'switch',
      onChange: onToggleIsPublicCallback,
    },
    {
      align: 'center',
      sortable: false,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.attachments.attachmentGrid.actions'
      ) as string,
      isNotDataProp: true,
    },
  ];
}

export function CallLogHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.user'
      ) as string,
      value: 'userName',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.status'
      ) as string,
      value: 'status',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.from'
      ) as string,
      value: 'fromNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.to'
      ) as string,
      value: 'toNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.duration'
      ) as string,
      value: 'duration',
      filters: [
        (val) => {
          val = Number(val);
          const h = Math.floor(val / 3600);
          const m = Math.floor((val % 3600) / 60);
          const s = Math.floor((val % 3600) % 60);
          const hDisplay = h > 0 ? h + 'h ' : '';
          const mDisplay = m > 0 ? m + 'm ' : '';
          const sDisplay = s > 0 ? s + 's ' : '';
          return hDisplay + mDisplay + sDisplay;
        },
      ],
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.callAt'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.calls.callLogGrid.actions'
      ) as string,
      sortable: false,
    },
  ];
}

export function TextLogHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.texts.textLogGrid.from'
      ) as string,
      value: 'fromNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.texts.textLogGrid.to'
      ) as string,
      value: 'toNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.texts.textLogGrid.text'
      ) as string,
      value: 'text',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.texts.textLogGrid.status'
      ) as string,
      value: 'status',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t(
        'partSalesAttachments.tabs.texts.textLogGrid.messageDateTime'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
    },
  ];
}

export function AttachmentsFields(
  onFileChangeCallback: (...args: any[]) => void,
  vm: any
): Array<VFields<any>> {
  return [
    {
      key: 'invoiceNumber',
      type: 'v-alynk-text-field',
      required: true,
      templateOptions: {
        counter: 50,
        label: vm.$parent.$t('partSalesAttachments.invoiceNumber') as string,
        validations: 'required',
        required: true,
        disabled: true,
        elementClass: 'col col-xs-12 col-sm-12 col-md-4 col-lg-4 float-left',
        loading: false,
      },
    },
    {
      key: 'attachmentTypeId',
      type: 'v-alynk-select',
      required: true,
      templateOptions: {
        label: vm.$parent.$t('partSalesAttachments.attachmentType') as string,
        validations: 'required',
        required: true,
        disabled: false,
        time: true,
        value: 'id',
        text: 'name',
        items: [],
        elementClass: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 float-left',
        loading: false,
      },
    },
    {
      key: 'isPublic',
      type: 'v-alynk-switch',
      required: false,
      templateOptions: {
        label: vm.$parent.$t('partSalesAttachments.isPublic') as string,
        disabled: false,
        validations: '',
        loading: false,
        elementClass: 'col-xs-12 col-sm-12 col-md-4 col-lg-4 float-left',
      },
    },
    {
      key: 'file',
      type: 'v-alynk-file-upload',
      required: true,
      templateOptions: {
        label: vm.$parent.$t('partSalesAttachments.attachment') as string,
        validations: 'required',
        required: true,
        disabled: false,
        multiple: false,
        events: {
          onChange: onFileChangeCallback as any,
        },
        loading: false,
      },
    },
    {
      key: 'comment',
      type: 'v-alynk-textarea',
      required: false,
      templateOptions: {
        counter: 250,
        maxlength:250,
        label: vm.$parent.$t('partSalesAttachments.comment') as string,
        validations: '',
        required: false,
        disabled: false,
        loading: false,
        elementClass: 'col-12 float-left mt-3',
      },
    },
  ];
}

export function RecceivedReportHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.reportType'
      ) as string,
      value: 'recordType',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.orderNumber'
      ) as string,
      value: 'orderNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.partNumber'
      ) as string,
      value: 'partNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: 'Packing Number',
      value: 'packingSlipNumber',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.manufacturer'
      ) as string,
      value: 'manufacturer',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.counterPersonName'
      ) as string,
      value: 'counterPersonName',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.quantity'
      ) as string,
      value: 'quantity',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.receivedQty'
      ) as string,
      value: 'receivedQty',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.receivedBy'
      ) as string,
      value: 'createdBy',
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t(
        'partSales.partReceivedReportGird.receivedAt'
      ) as string,
      value: 'createdAt',
      fieldType: 'date',
    },
  ];
}

export class AttachmentModel {
  public id?: string;
  public fileExtension?: string;
  public file?: string;
  public invoiceNumber?: string;
  public customerName?: string;
  public attachmentTypeId?: number;
  public attachmentTypeName?: string;
  public isPublic: boolean;
  public comment?: string;

  public createdDateTime?: string;
  public attachmentUri?: string;
  public userName?: string;
  public duration?: string;
  public status?: string;
  public fromNumber?: string;
  public toNumber?: string;
  public text?: string;
  public recordingSid?: string;
  public selected?: boolean;
  public showCallDetails?: boolean;
}

export class SendEmailModel {
  public from: string;
  public customer: boolean;
  public self: boolean;
}

export interface IFilter {
  invoiceNumber: string;
  sortName: string;
  transDate: string;
  counterPersonId: string;
  isOpenPartSaleOrder: boolean;
}

export class PartSale {
  public id: string;
  public invoiceNumber: string;
  public flag: string;
  public cashierStatus: string;
  public partsSalesJson: PartSalesJson;
}
export class PartSaleShipment {
  public id: string;
  public storeId: number;
  public recordKey: string;
  public orderId: string;
  public customerKey: string;
  public customerName: string;
  public customerPhoneNumber: string;
  public externalOrderId: string;
  // public response: PartSalesJson;
}

export class PartSaleCustomerModel {
  public customerPhoneNumber: string;
  public businessPhone: string;
  public cellPhone: string;
  public otherNumber: string;
  public callType: string;
  public customerKey: string;
  public customerName: string;
  public invoiceNumber: string;
  public callTo: string;
}

export interface IPartSaleBasicDetail {
  customerName: string;
  invoiceNumber: string;
  id: string;
}

export class UberRequesModel {
  public estimatedPrice: number;
  public estimateId: string;
  public placeId: string;
  public uberStoreId: string;
  public invoiceNumber: string;
  public shippingMethod: string;
  public customerKey: string;
}

export class PartSaleDetail {
  public invoiceNumber: string;
  public flag: string;
  public partsSalesJson: PartSalesJson;
  public store: PartSaleStoreDetail;
  public customer: PartSaleCustomerInfo;
  public displayDueAmount?: string;
  public loggedInUserEmail?: string;
  public loggedInUserId?: string;
  public isSubmitted?: boolean;
  public contactAt?: string;
  public paymentDetail?: IPaymentDetail;
  public status?: string;
  public cashierStatus?: string;
  public cards?: any;
  public customerId?: string;
  public recordIdentifier?: string;
  public isSendPaymentReceipt: boolean;


  public constructor() {
    this.store = new PartSaleStoreDetail();
    this.partsSalesJson = new PartSalesJson();
    this.customer = new PartSaleCustomerInfo();
  }
}
